module.exports = __webpack_public_path__ + "img/1.e3b7a2d7.png";